import classNames from 'classnames';
import { forwardRef } from 'react';
const sectionWrapperCss = "s9qdnex";
export const SectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionWrapperCss, props.className)} />;
});
const switchWrapperCss = "sbiaqh8";
export const SwitchWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(switchWrapperCss, props.className)} />;
});
const formSectionCss = "fhs5zp6";
export const FormSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formSectionCss, props.className)} />;
});
const dropdownButtonWrapperCss = "df941m5";
export const DropdownButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownButtonWrapperCss, props.className)} />;
});
const dropdownWrapperCss = "d1dcxwrg";
export const DropdownWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownWrapperCss, props.className)} />;
});
const optionContentCss = "o16s0mry";
export const OptionContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionContentCss, props.className)} />;
});
const optionLogoCss = "opxh7is";
export const OptionLogo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionLogoCss, props.className)} />;
});

require("./commerce_section_styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./commerce_section_styles.js");